import React from 'react';
import Icon from './IconBase';

interface IProps {
  [key: string]: any;
  width?: string | number;
}

function DoconLogo(props: IProps) {
  if (!(props.width || props.height)) {
    props = Object.assign({ ...props }, { width: 128 });
  }

  return (
    <Icon data-icon={'DoconLogo'} fill='none' viewBox='0 0 128 32'
      {...props}>

      <defs>
        <path id='prefix__a' d='M0.066 0.262L2.409 0.262 2.409 9.123 0.066 9.123z' />
        <path id='prefix__c' d='M0.085 0.313L3.278 0.313 3.278 9.71 0.085 9.71z' />
        <path id='prefix__e' d='M0.601 0.233L3.714 0.233 3.714 10.538 0.601 10.538z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path fill='#0089FF' d='M15.998 31.789c-2.417 0-4.914.192-7.321-.048C4.016 31.277.284 27.366.05 22.71c-.105-2.098-.012-4.219-.012-6.318V7.205c0-.718-.045-1.461.045-2.175.29-2.312 2.03-4.27 4.3-4.843C5.395-.069 6.488.012 7.525.012h4.832c3.11 0 6.17-.12 9.148.972 4.28 1.57 7.756 4.976 9.393 9.216 3.445 8.92-2.055 19.133-11.424 21.21-1.14.252-2.31.379-3.477.379' />
        <path fill='#FFF' d='M14.774 23.742c-3.445 0-6.545-2.303-7.538-5.6-.163-.542.144-1.115.687-1.278.542-.163 1.114.144 1.277.686.734 2.439 3.026 4.14 5.574 4.14s4.84-1.701 5.574-4.14c.163-.542.735-.849 1.277-.686.543.163.85.736.687 1.278-.993 3.297-4.093 5.6-7.538 5.6' />
        <g>
          <g transform='translate(7.382 7.32) translate(6.154 15.385)'>
            <mask id='prefix__b' fill='#fff'>
              <use xlinkHref='#prefix__a' />
            </mask>
            <path fill='#FFF' fillOpacity='.6' d='M2.409 9.084L0.065 9.123 0.065 0.262 2.409 0.262z'
              mask='url(#prefix__b)' />
          </g>
          <path fill='#FFF' d='M2.676 3.181h-1.08c-.575 0-1.04-.465-1.04-1.04v-.58c0-.574.465-1.04 1.04-1.04h1.08c.574 0 1.039.466 1.039 1.04v.58c0 .575-.465 1.04-1.04 1.04M13.076 3.181h-1.08c-.574 0-1.038-.465-1.038-1.04v-.58c0-.574.464-1.04 1.038-1.04h1.08c.575 0 1.04.466 1.04 1.04v.58c0 .575-.465 1.04-1.04 1.04' transform='translate(7.382 7.32)' />
        </g>
        <g transform='translate(6.767 8.55)'>
          <mask id='prefix__d' fill='#fff'>
            <use xlinkHref='#prefix__c' />
          </mask>
          <path fill='#FFF' fillOpacity='.3' d='M.892 9.71L.09 2.257C.013 1.337.719.523 1.664.443L3.2.313l.078.923-1.536.13c-.422.036-.737.4-.703.81l.8 7.454-.947.08z'
            mask='url(#prefix__d)' />
        </g>
        <g>
          <g transform='translate(19.075 3.628) translate(0 4.923)'>
            <mask id='prefix__f' fill='#fff'>
              <use xlinkHref='#prefix__e' />
            </mask>
            <path fill='#FFF' fillOpacity='.3' d='M2.747 10.538l.958-8.307C3.798 1.306 3.122.478 2.197.384L.694.233l-.093.928 1.502.151c.414.042.716.412.675.826l-.959 8.307.928.093z'
              mask='url(#prefix__f)' />
          </g>
          <path fill='#191B21' d='M46.78 20.097c-2.038 0-3.397-1.613-3.397-3.63 0-1.954 1.359-3.536 3.398-3.536 2.008 0 3.367 1.582 3.367 3.536 0 2.017-1.36 3.63-3.367 3.63m-.032-11.51c-4.726 0-8.125 3.32-8.125 7.85 0 4.59 3.4 8.004 8.125 8.004 4.728 0 8.126-3.413 8.126-8.005 0-4.53-3.398-7.85-8.126-7.85M28.999 20.097c-2.039 0-3.398-1.613-3.398-3.63 0-1.954 1.36-3.536 3.398-3.536 2.008 0 3.367 1.582 3.367 3.536 0 2.017-1.36 3.63-3.367 3.63M35.775.571h-2.928c-.572 0-1.036.463-1.036 1.035v7.421c-.872-.286-1.827-.44-2.843-.44-4.727 0-8.125 3.32-8.125 7.85 0 4.59 3.398 8.004 8.125 8.004 1.046 0 2.025-.17 2.919-.48.149.389.519.667.96.667h2.928c.571 0 1.034-.463 1.034-1.035V1.606c0-.572-.463-1.035-1.034-1.035M82.628 20.097c-2.039 0-3.398-1.613-3.398-3.63 0-1.954 1.36-3.536 3.398-3.536 2.008 0 3.368 1.582 3.368 3.536 0 2.017-1.36 3.63-3.368 3.63m-.031-11.51c-4.726 0-8.125 3.32-8.125 7.85 0 4.59 3.399 8.004 8.125 8.004 4.727 0 8.125-3.413 8.125-8.005 0-4.53-3.398-7.85-8.125-7.85M71.408 17.972h-2.66c-.427 0-.793.266-.968.655-.454 1.02-1.489 1.659-2.81 1.659-2.187 0-3.519-1.617-3.519-3.71 0-2.092 1.332-3.676 3.519-3.676 1.321 0 2.356.638 2.81 1.658.175.389.54.656.967.656h2.913c.648 0 1.122-.614.959-1.241-.855-3.273-3.86-5.416-7.649-5.416-4.85 0-8.4 3.36-8.4 8.02 0 4.691 3.55 8.052 8.4 8.052 3.673 0 6.611-2.015 7.565-5.121.234-.763-.33-1.536-1.127-1.536M101.784 8.6c-1.333 0-2.467.406-3.51 1.07-.38.244-.882-.038-.882-.491 0-.32-.259-.579-.578-.579h-2.81c-.892 0-1.614.723-1.614 1.614v13.4c0 .574.465 1.039 1.04 1.039h3.34c.574 0 1.04-.465 1.04-1.04v-7.925c0-.925 1.307-2.272 2.95-2.269 1.738.003 2.885 1.08 2.885 3.341v6.843c0 .58.471 1.05 1.05 1.05h2.923c.569 0 1.03-.46 1.03-1.03v-8.447c.108-3.186-2.804-6.576-6.864-6.576' transform='translate(19.075 3.628)' />
        </g>
      </g>
    </Icon >
  );
}

export default DoconLogo;